import { frFR, deDE, enUS } from '@clerk/localizations';
import { useTranslation } from 'react-i18next';
import deepMerge from 'utils/deepMerge';
import getGlobalClerkIntlContent from 'locale/getGlobalClerkIntlContent';

export const getClerkLocale = locale => {
  switch (locale) {
    case 'fr-CH':
      return frFR;
    case 'de-CH':
      return deDE;
    case 'en-US':
      return enUS;
    default:
      return deDE;
  }
};

export const getCustomClerkLocalizations = ({ clerkLocale, globalOverrides }) => {
  return deepMerge({}, clerkLocale, globalOverrides);
};

const useClerkLocale = () => {
  const { i18n } = useTranslation();
  const clerkLocale = getClerkLocale(i18n.language);
  const globalOverrides = getGlobalClerkIntlContent(i18n.language);

  return getCustomClerkLocalizations({
    clerkLocale,
    globalOverrides,
  });
};

export default useClerkLocale;
